// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <detail-view
  :endpoint="endpoint + 'locationtags'"
  :hiddenValues="hiddenValues"
  name="Location Tag"
  parentRoute="locationtags"
  permissions="locationtags"
  :values="values"
  v-model="data"
  ></detail-view>
</template>
<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      data: {},
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Tag',
                value: 'tag',
                required: true
              },
              {
                name: 'Zone',
                value: 'zone',
                context: ENDPOINT + 'zones?limit=1000',
                type: 'select',
                itemText: 'name',
                itemValue: '_id'
              },
              {
                name: 'Map',
                value: 'map',
                context: ENDPOINT + 'maps',
                type: 'select',
                itemText: 'name',
                itemValue: '_id',
                multiple: false
              },
              {
                name: 'Coordinate (X)',
                value: 'xycoordinates.0',
                required: false,
                valueType: 'number',
                width: 'xs6 md2'
              },
              {
                name: 'Coordinate (Y)',
                value: 'xycoordinates.1',
                required: false,
                valueType: 'number',
                width: 'xs6 md2'
              }
            ]
          ]
        },
        {
          name: 'QR Code',
          items: [
            [
              {
                text: 'QR Code',
                prefix: '',
                value: 'tag',
                component: 'qr-holder',
                type: 'component'
              }
            ]
          ]
        }
      ]
    }
  },

  created: function () {
    if (this.$route.params.id === 'new') {
      this.data.xycoordinates = []
    }
  },

  watch: {
    data: function () {
      if (this.data.xycoordinates === null) {
        this.data.xycoordinates = []
      }
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ]),

    hiddenValues: function () {
      return [{
        path: 'site',
        value: this.selectedSite._id
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/LocationTagEdit.vue